import React, { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { Loading } from "../../components";
import useRouting from "../../contexts/Routing";
import useCurrentSession from "../../contexts/session";
import "./Homepage.css";
import usePortal from "../../contexts/PortalContext";
import isAllowedRedirect from "../../redirect";

const FEATURE_DEFAULT_HOME = "frontend.default.home";

export default function Homepage() : ReactElement | null {
    const { getSearchParams, Paths, historyPush } = useRouting();

    const { featureFlags } = usePortal();

    const { redirect, isWaitLogin } = getSearchParams(Paths.DEFAULT);
    const session = useCurrentSession();
    if (redirect && isAllowedRedirect(redirect)) {
        if (session.isLoggedIn) {
            return <Navigate to={redirect} />;
        } if (isWaitLogin === "true") {
            return <Loading />;
        }
    } else if (session.isLoggedIn && featureFlags.has(FEATURE_DEFAULT_HOME)) {
        historyPush(Paths.HOME);
    } else {
        historyPush(Paths.ANSWERS_LIST);
    }
    return null;
}
